import { COL_NAME_CAMERA, COL_NAME_CAUTION, COL_NAME_DAYTIME, COL_NAME_MANAGEMENT_ID, COL_NAME_NIGHTTIME, COL_NAME_ROUTE_DATA, COL_NAME_ROUTE_NAME, COL_NAME_TRAFFIC_DIRECTION, COL_NAME_WARNING } from "pages/TrafficMonitoring/constants";

export const TRAFFIC_MONITORING_PROPERTIES = {
    NO: COL_NAME_MANAGEMENT_ID,
    NAME: COL_NAME_ROUTE_NAME,
    ROUTE_DATA: COL_NAME_ROUTE_DATA,
    TRAFFIC_DIRECTION: COL_NAME_TRAFFIC_DIRECTION,
    CAMERA_BASE: `${COL_NAME_CAMERA}拠点`,
    SCENARIO_NO: '断面No',
    DAYTIME_CAUTION: `${COL_NAME_DAYTIME}(${COL_NAME_CAUTION})`,
    DAYTIME_WARNING: `${COL_NAME_DAYTIME}(${COL_NAME_WARNING})`,
    NIGHTTIME_CAUTION: `${COL_NAME_NIGHTTIME}(${COL_NAME_CAUTION})`,
    NIGHTTIME_WARNING: `${COL_NAME_NIGHTTIME}(${COL_NAME_WARNING})`,
}

// messages
export const DUPLICATE_ROUTE_ID = '路線Noが重複しています。';
export const DUPLICATE_ROUTE_NAME = '路線名が重複しています。';
export const MSG_ROUTE_NAME_EMPTY = '路線名称が未入力です。';
export const MSG_ROUTE_ID_EMPTY = '路線Noが未入力です。';
export const MSG_FILE_EXTENSION_INVALID = 'アップロードできないファイルです。';
export const MSG_FILE_FORMAT_INVALID = 'データ形式が不正です。';
export const MSG_FILE_EMPTY = 'アップロード対象のファイルがありません。';
export const MSG_DIRECTION_EMPTY = (order) => `交通方向番号${order}が入力されていません。`;
export const MSG_CAMERA_EMPTY = (order) => `カメラ${order}の拠点がが未入力です。`;
export const MSG_SCENARIO_EMPTY = (order) => `カメラ${order}の断面Noが未入力です。`;
export const MSG_DAYTIME_CAUTION_EMPTY = (order) => `カメラ${order}の昼夜注意閾値が未入力です。`;
export const MSG_DAYTIME_WARNING_EMPTY = (order) => `カメラ${order}の昼夜警報閾値が未入力です。`;
export const MSG_DAYTIME_CAUTION_WARNING_INVALID = '閾値は、警報<注意としてください。';
export const MSG_NIGHTTIME_WARNING_EMPTY = (order) => `カメラ${order}の深夜注意閾値が未入力です。`;
export const MSG_NIGHTTIME_CAUTION_EMPTY = (order) => `カメラ${order}の深夜警報閾値が未入力です。`;
export const MSG_NIGHTTIME_CAUTION_WARNING_INVALID = '閾値は、警報<注意としてください。';